<template>
    <div ref="domNode" class="sc-emoji-picker" tabindex="0" @blur="$emit('value',false)">
        <div class="sc-emoji-picker--content">
            <div v-for="category in emojiData" :key="category.name" class="sc-emoji-picker--category">
                <div class="sc-emoji-picker--category-title">{{ category.name }}</div>
                <span
                    v-for="emoji in category.emojis"
                    :key="emoji"
                    class="sc-emoji-picker--emoji"
                    @click="emojiClicked(emoji)"
                >
                    {{ emoji }}
                </span>
            </div>
            <div class="sc-back-icon">
                x
            </div>
        </div>
    </div>
</template>

<script>
import EmojiConvertor from "emoji-js";
import emojiData from "./emojiData";

export default {
    data() {
        return {
            emojiData,
            emojiConvertor: new EmojiConvertor(),
        };
    },
    props: {
        onEmojiPicked: {
            type: Function,
            required: true,
        },
    },
    methods: {
        emojiClicked(emoji) {
            this.onEmojiPicked(emoji);
            this.$refs.domNode.blur();
        },
    },
    mounted() {
        const elem = this.$refs.domNode;
        elem.style.opacity = 0;
        window.requestAnimationFrame(() => {
            elem.style.transition = "opacity 350ms";
            elem.style.opacity = 1;
        });
        this.$refs.domNode.focus();
        this.emojiConvertor.init_env();
    },
};
</script>

<style>
.sc-emoji-picker {
    position: absolute;
    /* Giris cubugunun tam ustu: sabit piksel degeri cubuk yukseldiginde
       uzerine biniyordu. */
    bottom: calc(100% + 8px);
    left: 12px;
    right: 12px;
    max-height: 240px;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16), 0 2px 6px rgba(15, 23, 42, 0.08);
    /* Saydam zemin altindaki giris alanini gosteriyordu */
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: var(--sps-radius-lg, 16px);
    outline: none;
    overflow: hidden;
    animation: sps-pop-in 160ms cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: bottom center;
}

@keyframes sps-pop-in {
    from {
        opacity: 0;
        transform: translateY(8px) scale(0.98);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@media (prefers-reduced-motion: reduce) {
    .sc-emoji-picker {
        animation: none;
    }
}

.sc-emoji-picker:after {
    content: none;
    width: 14px;
    height: 14px;
    background: transparent;
    position: absolute;
    bottom: -6px;
    right: 55px;
    transform: rotate(45deg);
    border-radius: var(--sps-radius-xs);
}

.sc-emoji-picker--content {
    padding: 10px;
    overflow: auto;
    width: 100%;
    max-height: 195px;
    margin-top: 7px;
    box-sizing: border-box;
}

.sc-emoji-picker--category {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.sc-emoji-picker--category-title {
    min-width: 100%;
    color: #8f7b7b;
    font-weight: 200;
    font-size: 13px;
    margin: 5px;
    letter-spacing: 1px;
}

.sc-emoji-picker--emoji {
    margin: 5px;
    width: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    vertical-align: middle;
    font-size: 28px;
    transition: transform 60ms ease-out, -webkit-transform 60ms ease-out;
}

.sc-emoji-picker--emoji:hover {
    transform: scale(1.4);
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/EmojiPicker.vue